namespace GeniuzPOS.AdvPromo {
    export enum AssortFg {
        AssortFg1 = 0,
        AssortFg2 = 1
    }
    Serenity.Decorators.registerEnumType(AssortFg, 'GeniuzPOS.AdvPromo.AssortFg');
}
